import { render, staticRenderFns } from "./Handles.vue?vue&type=template&id=df553b68&"
import script from "./Handles.vue?vue&type=script&lang=ts&"
export * from "./Handles.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports